import { defineStore } from 'pinia';
import { ref } from 'vue';
import { villusClient } from '../villusClient';
import { graphqlGetTranslations } from '../utils/queryGraphql';

export const useTranslationsStore = defineStore('translations', () => {
  const translations = ref({});
  const locale = ref(getShopifyLocale());

  async function fetchTranslations() {
    const query = graphqlGetTranslations;
    const result = await villusClient.executeQuery({
      query,
      variables: {
        language: locale.value,
      },
    });
    const edges = result.data?.metaobjects?.edges || [];

    const map = {};

    for (const { node } of edges) {
      const keyField = node.fields.find((f) => f.key === 'key');
      const textField = node.fields.find((f) => f.key === 'text_value');

      const entryKey = keyField?.value;
      const rawValue = textField?.value;

      if (entryKey && rawValue) {
        try {
          const parsed = JSON.parse(rawValue);
          const text = parsed.children?.[0]?.children?.[0]?.value || '';
          map[entryKey] = text;
        } catch (e) {
          console.warn(`Failed to parse translation for ${entryKey}`, e);
        }
      }
    }

    translations.value = map;
    console.log(translations)
  }

  function t(key, options = {}) {
    const raw = translations.value[key];
    if (!raw) return key;

    const { count, type = 'service', replace = {} } = options;

    // Handle double pluralization (type + count)
    if (count !== undefined && raw.includes('||')) {
      const [servicePart, spaPart] = raw.split('||').map(s => s.trim());
      const text = (type === 'center' ? spaPart : servicePart).split('|').map(s => s.trim());
      const template = count === 1 ? text[0] : text[1];
      return template.replace('{count}', count);
    }

    // Basic plural handling
    if (count !== undefined && raw.includes('|')) {
      const [singular, plural] = raw.split('|').map(s => s.trim());
      const template = count === 1 ? singular : plural;
      return template.replace('{count}', count);
    }

    // Basic string replacement
    return Object.entries(replace).reduce(
      (acc, [k, v]) => acc.replaceAll(`{${k}}`, v),
      raw
    );
  }

  function setLocale(lang) {
    locale.value = lang.toUpperCase();
    fetchTranslations();
  }
  function getShopifyLocale() {
    if (typeof window !== 'undefined' && window.Shopify?.locale) {
      return window.Shopify.locale.toUpperCase();
    }
    return 'FR';
  }
  return {
    translations,
    locale,
    fetchTranslations,
    setLocale,
    t,
    getShopifyLocale,
  };
});